module.exports = __webpack_public_path__ + "static/media/search-dark.19ebefc1.svg";